'use strict';
exports.default = exports;
const _ = require('lodash');
const listModels = require('./ListModels');

/**
 *
 * @param {ConfigTable|string} config
 * @param {any} data
 * @param {boolean} [preserveFields=false] preserveFields
 * @returns {{}}
 */
exports.getUpdateObj = function(config, data, preserveFields= undefined) {
  config = exports.getConfig(config);
  if(!config) {
    return null;
  }
  if(typeof preserveFields==='undefined') {
    preserveFields = config.preserveFields;
  }

  let object = _.cloneDeep(data) || {};
  let ret = {};
  if(preserveFields) {
    ret = object || {};
  }
  if(typeof config.beforeProcess==='function') {
    object = config.beforeProcess(object);
  }

  for(const field of config.fields) {
    if(field.removeBeforeSave) {
      delete ret[field.cDestiny];
    }
    else {
      ret[field.cDestiny] = exports.getValue(config, field, object[field.cOrigin], preserveFields);
      if(typeof ret[field.cDestiny]==='undefined') {
        delete ret[field.cDestiny];
      }
    }
  }
  if(typeof config.afterProcess==='function') {
    ret = config.afterProcess(ret);
  }
  return ret;
};

/**
 *
 * @param {ConfigTable|string} config
 * @returns {ConfigTable|null}
 */
exports.getConfig = function(config) {
  let ret = null;
  if(typeof config==='string') {
    ret = listModels[config] || null;
  }
  else if(typeof config==='object') {
    ret = config;
  }
  if(!ret || !ret.name) {
    console.error('Not found config', ret);
    return null;
  }
  return ret || null;
};


exports.currency = function(number) {
  const factor = Math.pow(10, 2);
  const roundedTempNumber = Math.round(number * factor);
  return (roundedTempNumber/factor) || 0;
};

/**
 *
 * @param {ConfigTable|string} config
 * @param {Field} field
 * @param {any} data
 * @param preserveFields
 * @returns {any}
 */
exports.getValue = function(config, field, data, preserveFields=false) {
  config = exports.getConfig(config);
  if(!config) {
    return null;
  }
  let vtmp = data;
  if(typeof data==='undefined') {
    vtmp = field.defaultValue;
  }
  switch (field.type) {
    case 'boolean':
      vtmp = Boolean(vtmp);
      break;
    case 'number':
      vtmp = Number(vtmp);
      break;
    case 'string':
      if(vtmp!==null) {
        vtmp = String(vtmp);
      }
      break;
    case 'Timestamp':
      break;
    case 'Original':
      break;
    case 'Currency':
      vtmp = exports.currency(vtmp);
      break;
    case 'Struct':
      vtmp = exports.getStruct(config, field, data, preserveFields);
      break;
    case 'StructFk':
      vtmp = exports.getStructFk(config, field, data, preserveFields);
      break;
    case 'object':
      break;
    case 'Array':
      break;
    case 'ArrayFk':
      vtmp = exports.getArrayFk(config, field, data);
      break;
    case 'ArrayString':
      vtmp = exports.getArrayString(config, field, data);
      break;
    default:
      console.error('Error, type: ' + field.type + ' não reconhecido', field, data);
    // continue;
  }
  return vtmp;
};

/**
 *
 * @param {ConfigTable|string} config
 * @param {Field} field
 * @param {any} data
 * @returns {{}}
 */
exports.getArrayString = function(config, field, data) {
  const ret = [];
  if(Array.isArray(data)) {
    for(const d of data) {
      const v = String(d);
      if(v) {
        ret.push(v);
      }
    }
  }
  return ret;
};

/**
 *
 * @param {ConfigTable|string} config
 * @param {Field} field
 * @param {any} data
 * @returns {{}}
 */
exports.getArrayFk = function(config, field, data) {
  config = exports.getConfig(field.fk);
  if(!config) {
    return null;
  }
  const ret = [];
  if(Array.isArray(data)) {
    for(const d of data) {
      const v = exports.getStructFk(config, field, d);
      if(v) {
        ret.push(v);
      }
    }
  }
  return ret;
};

/**
 *
 * @param {ConfigTable|string} config
 * @param {Field} field
 * @param {any} data
 * @param preserveFields
 * @returns {{}}
 */
exports.getStructFk = function(config, field, data, preserveFields=false) {
  config = exports.getConfig(field.fk);
  if(!config) {
    return null;
  }
  let ret = {};
  if(preserveFields) {
    ret = data || {};
  }

  for(const f of config.fields || []) {
    if(f.removeBeforeSave) {
      delete ret[f.cDestiny];
    }
    else if(f.items?.length) {
      for(const item of f.items || []) {
        if(item.removeBeforeSave) {
          delete ret[item.cDestiny];
        }
        else {
          ret[item.cDestiny] = exports.getValue(config, item, data ? data[f.cOrigin] : undefined, preserveFields);
          if(typeof ret[item.cDestiny]==='undefined') {
            delete ret[item.cDestiny];
          }
        }
      }
    }
    else {
      ret[f.cDestiny] = exports.getValue(config, f, data ? data[f.cOrigin] : undefined);
      if(typeof ret[f.cDestiny]==='undefined') {
        delete ret[f.cDestiny];
      }
    }
  }
  return ret;
};

/**
 *
 * @param {ConfigTable|string} config
 * @param {Field} field
 * @param {any} data
 * @param preserveFields
 * @returns {{}}
 */
exports.getStruct = function(config, field, data, preserveFields=false) {
  config = exports.getConfig(config);
  if(!config) {
    return null;
  }
  let ret = {};
  if(preserveFields) {
    ret = data || {};
  }
  for(const f of field.items || []) {
    if(f.removeBeforeSave) {
      delete ret[f.cDestiny];
    }
    else {
      ret[f.cDestiny] = exports.getValue(config, f, data ? data[f.cOrigin] : undefined, preserveFields);
      if(typeof ret[f.cDestiny]==='undefined') {
        delete ret[f.cDestiny];
      }
    }
  }
  return ret;
};




/**
 *
 * @param firestore
 * @param config ConfigTable
 * @param data Object
 * @returns {Promise}
 */
exports.update = async function(firestore, config, data) {
  config = exports.getConfig(config);
  if(!config) {
    return null;
  }
  const object = exports.getUpdateObj(config, data);
  const pKey = object[config.pKey];
  // if(config.pKey) {
  //
  // }
  return firestore.collection(config.tableDestiny).doc(pKey).set(object, {merge: true});
};




/**
 * @param firestore
 * @param config ConfigTable
 * @param pKey String
 * @returns {Promise}
 */

exports.delete = async function(firestore, config, pKey) {
  config = exports.getConfig(config);
  if(!config) {
    return null;
  }
  return firestore.collection(config.tableDestiny).doc(pKey).delete();
};



